import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchInactive,
  fetchCatinactive,
  fetchCatincompleteinfo,
  pushCatincompleteinfo,
  fetchInactiveCategory,
  fetchPtmGpsapirt,
  fetchInactivePeriode,
  fetchInactiveDaily
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushZonaTarget, pushPoiTarget } from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { NavLink, withRouter } from "react-router-dom";
import Button from "components/CustomButtons/Button.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormGroup from "@material-ui/core/FormGroup";
import _ from "lodash";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InactiveCat from "./inactivecat";
import IconSettings from "@material-ui/icons/Settings";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import Grid from "@material-ui/core/Grid";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import moment from "moment";
import { pushLoader } from "../../actions/main";
import BlockUi from "react-block-ui";
import ReactExport from "assets/libs/react-export-excel";
import { TextField } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Inactive ${moment().format("LLL")}`;

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  }
});

let delay = null;

class Inactive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      dataExcel: [],
      openAdd: false,
      category: [],
      selectedCategory: "",
      selectedCategoryPeriode: "1",
      catinactive: [],
      inactivechartdata: [],
      inactivechartcat: [],
      description: "",
      sourceAis: "GPS",
      loader: null,
      loader2: null,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DDT06:10"),
      endDate: moment().format("YYYY-MM-DDT06:10"),
      pageTable: 0,
      totalData: 100,
      searchCheck: null,
      sort: [
        "none",
        "none",
        "desc",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      orderby: `"dateCreated"`,
      activeColumn: 2,
      displayStatus: [true, true, true, true, true, false, false, true, true],
      serverSideStatus: true
    };
  }

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true, loader2: true });
    fetchCatinactive()
      .then(response => {
        if (response != null) {
          const dat = response.data.results;
          let dataactual = dat.push({
            deleted: 0,
            description: "",
            id: 0,
            name: "Aktual",
            timeidle: "0"
          });
          this.setState({
            catinactive: dat,
            selectedCategory: dat[0].id,
            description:
              dat[0].description + " idle time in hours " + dat[0].timeidle
          });
          fetchInactiveDaily()
            .then(response => {
              if (response != null) {
                let cat = [];
                let val = [];
                response.data.map(e => {
                  if (e[0] !== "-" && e[0] !== null) {
                    cat.push(e[0]);
                    val.push(e[1]);
                  }
                });

                this.setState({
                  inactivechartcat: cat,
                  inactivechartdata: val
                });
              }
              this.setState({ loader: false });
            })
            .catch(error => {
              console.log(error);
              // this.props.history.push("/pages/login#logout");
            });
          this.handleSearch(null, null, 10, 0);
          // fetchInactive(dat[0].id, "1", this.state.sourceAis)
          //   .then((response) => {
          //     if (response != null) {
          //       let datanya = [];

          //       for (var key in response.data.results) {
          //         var aa = _.values(response.data.results[key]);
          //         console.log(aa);
          //         aa[4] = moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
          //           "YYYY-MM-DD HH:mm:ss"
          //         );
          //         datanya.push({
          //           name: aa[2],
          //           shiptype: this.getNameshiptype(aa[3]),
          //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
          //             "DD-MM-YYYY HH:mm:ss"
          //           ),
          //           latitude: aa[5],
          //           longitude: aa[6],
          //           category: aa[7],
          //           delayinminutes: parseFloat(aa[11]).toFixed(2),
          //           call_sign: aa[10],
          //           status_name: aa[12],
          //           checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
          //             "DD-MM-YYYY HH:mm:ss"
          //           ),
          //           inactivetime: ">" + aa[9] + " Hours",
          //         });
          //       }
          //       this.setState({ datatable: datanya });
          //     }
          //     this.setState({ loader2: false });
          //   })
          //   .catch((error) => {
          //     //this.props.pushToken(error);
          //   });
        }
        this.props.pushLoader(false);
      })
      .catch(error => {
        console.log(error);
        this.props.pushLoader(false);
        this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // this.setState({ sourceAis: nextProps.sourceAis });
    // fetchInactiveCategory(
    //   this.state.selectedCategory,
    //   this.state.selectedCategoryPeriode,
    //   nextProps.sourceAis
    // )
    //   .then(response => {
    //     if (response != null) {
    //       let cat = [];
    //       let val = [];
    //       response.data.map(e => {
    //         cat.push(e[0]);
    //         val.push(e[1]);
    //       });
    //       this.setState({
    //         inactivechartcat: cat,
    //         inactivechartdata: val
    //       });
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     // this.props.history.push("/pages/login#logout");
    //   });
    // fetchInactive(
    //   this.state.selectedCategory,
    //   this.state.selectedCategoryPeriode,
    //   nextProps.sourceAis
    // )
    //   .then(response => {
    //     if (response != null) {
    //       let datanya = [];
    //       for (var key in response.data.results) {
    //         var aa = _.values(response.data.results[key]);
    //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
    //         datanya.push({
    //           name: aa[2],
    //           shiptype: this.getNameshiptype(aa[3]),
    //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           latitude: aa[5],
    //           longitude: aa[6],
    //           category: aa[7],
    //           delayinminutes: parseFloat(aa[11]).toFixed(2),
    //           call_sign: aa[10],
    //           status_name: aa[12],
    //           checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           inactivetime: ">" + aa[9] + " Hours"
    //         });
    //       }
    //       this.setState({ datatable: datanya });
    //     }
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //     // this.props.history.push("/pages/login#logout");
    //   });
  }

  handleRowSelect = e => {
    //this.props.pushLeftPanel(!this.props.leftPanel);
    //this.props.pushPoiTarget([e[5], e[6]]);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleChange = e => {
    const a = e.target.value.split("|");
    pushCatincompleteinfo(a[0], a[1], e.target.checked)
      .then(response => {
        fetchCatincompleteinfo()
          .then(responsex => {
            if (responsex != null) {
              this.setState({ category: responsex.data.results });
            }
          })
          .catch(error => {
            //this.props.pushToken(error);
            this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handlecatSource = e => {
    this.setState({ sourceAis: e.target.value });

    fetchInactiveCategory(
      this.state.selectedCategory,
      this.state.selectedCategoryPeriode,
      e.target.value
    )
      .then(response => {
        if (response != null) {
          let cat = [];
          let val = [];
          response.data.map(e => {
            if (e[0] !== "-" && e[0] !== null) {
              cat.push(e[0]);
              val.push(e[1]);
            }
          });

          this.setState({
            inactivechartcat: cat,
            inactivechartdata: val
          });
        }
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    this.handleSearchClick("source", e.target.value);

    // fetchInactive(
    //   this.state.selectedCategory,
    //   this.state.selectedCategoryPeriode,
    //   e.target.value
    // )
    //   .then((response) => {
    //     if (response != null) {
    //       let datanya = [];
    //       for (var key in response.data.results) {
    //         var aa = _.values(response.data.results[key]);
    //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
    //         datanya.push({
    //           name: aa[2],
    //           shiptype: this.getNameshiptype(aa[3]),
    //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           latitude: aa[5],
    //           longitude: aa[6],
    //           category: aa[7],
    //           delayinminutes: parseFloat(aa[11]).toFixed(2),
    //           call_sign: aa[10],
    //           status_name: aa[12],
    //           checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           inactivetime: ">" + aa[9] + " Hours",
    //         });
    //       }
    //       this.setState({ datatable: datanya });
    //     }
    //   })
    //   .catch((error) => {
    //     //this.props.pushToken(error);
    //   });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleKeyword = async e => {
    await this.setState({ keyword: e });
    await this.handleSearch(null, null, 10, 0);
  };

  handleSearchClick = async (category, data) => {
    await this.setState({
      searchCheck: true,
      sort: [
        "none",
        "none",
        "desc",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
      ],
      orderby: `"dateCreated"`,
      activeColumn: 2
    });
    if (category === "cat") {
      this.handleSearch(data, null, 10, 0);
    } else if (category === "source") {
      this.handleSearch(null, data, 10, 0);
    } else {
      this.handleSearch(null, null, 10, 0);
    }
  };

  handleSearch = async (category, source, row, page) => {
    this.setState({ loader2: true, datatable: [] });
    await fetchInactivePeriode(
      category ? category : this.state.selectedCategory,
      source ? source : this.state.sourceAis,
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      row,
      page * row,
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : ""
    )
      .then(response => {
        if (response != null) {
          let datanya = [];
          for (var key in response.data.results) {
            var aa = _.values(response.data.results[key]);
            //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
            datanya.push({
              name: aa[2],
              shiptype: this.getNameshiptype(aa[3]),
              dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              latitude: aa[5],
              longitude: aa[6],
              category: aa[7],
              delayinminutes: parseFloat(aa[11]).toFixed(2),
              call_sign: aa[10],
              status_name: aa[12],
              checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              inactivetime: ">" + aa[9] + " Hours"
            });
          }
          this.setState({ datatable: datanya });
        }
        this.setState({ totalData: response.data.total });
      })
      .catch(error => {
        console.log(error);
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });

    await fetchInactivePeriode(
      category ? category : this.state.selectedCategory,
      source ? source : this.state.sourceAis,
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      1000,
      0,
      this.state.orderby,
      this.state.sort[this.state.activeColumn],
      this.state.keyword ? this.state.keyword.toUpperCase() : ""
    )
      .then(response => {
        if (response != null) {
          let dataexcel = [];
          for (var key in response.data.results) {
            var aa = _.values(response.data.results[key]);
            //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
            dataexcel.push({
              name: aa[2],
              shiptype: this.getNameshiptype(aa[3]),
              dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              latitude: aa[5],
              longitude: aa[6],
              category: aa[7],
              delayinminutes: parseFloat(aa[11]).toFixed(2),
              call_sign: aa[10],
              status_name: aa[12],
              checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              inactivetime: ">" + aa[9] + " Hours"
            });
          }
          this.setState({ dataExcel: dataexcel });
        }
      })
      .catch(error => {
        console.log(error);
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
    this.setState({ loader2: false });
  };

  renderOptcat = e => {
    // console.log(e);
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  renderOpt = e => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={e.deleted}
            onChange={this.handleChange}
            value={`${e.id}|${e.name}`}
            color="primary"
          />
        }
        label={e.name}
      />
    );
  };

  handlecatperiode = async e => {
    await this.setState({
      selectedCategoryPeriode: e.target.value,
      startDate: moment()
        .subtract(e.target.value, "days")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm")
    });

    await fetchInactiveCategory(
      this.state.selectedCategory,
      e.target.value,
      this.state.sourceAis
    )
      .then(response => {
        if (response != null) {
          let cat = [];
          let val = [];
          response.data.map(e => {
            if (e[0] !== "-" && e[0] !== null) {
              cat.push(e[0]);
              val.push(e[1]);
            }
          });

          this.setState({
            inactivechartcat: cat,
            inactivechartdata: val
          });
        }
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });

    this.handleSearchClick(null, null);
    // fetchInactive(
    //   this.state.selectedCategory,
    //   e.target.value,
    //   this.state.sourceAis
    // )
    //   .then((response) => {
    //     if (response != null) {
    //       let datanya = [];
    //       for (var key in response.data.results) {
    //         var aa = _.values(response.data.results[key]);
    //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
    //         datanya.push({
    //           name: aa[2],
    //           shiptype: this.getNameshiptype(aa[3]),
    //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           latitude: aa[5],
    //           longitude: aa[6],
    //           category: aa[7],
    //           delayinminutes: parseFloat(aa[11]).toFixed(2),
    //           call_sign: aa[10],
    //           status_name: aa[12],
    //           checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
    //             "DD-MM-YYYY HH:mm:ss"
    //           ),
    //           inactivetime: ">" + aa[9] + " Hours",
    //         });
    //       }
    //       this.setState({ datatable: datanya });
    //     }
    //   })
    //   .catch((error) => {
    //     //this.props.pushToken(error);
    //   });
  };

  handlecat = async e => {
    const a = this.state.catinactive;
    const b = _.find(a, { id: e.target.value });

    await this.setState({
      selectedCategory: e.target.value,
      description: b.description + " inactive time in hours " + b.timeidle,
      serverSideStatus: true
    });

    if (e.target.value == 0) {
      fetchPtmGpsapirt()
        .then(async response => {
          await this.setState({ loader2: true, datatable: [] });
          if (response != null) {
            let datanya = [];
            let datenow = moment().format("DD-MM-YYYY HH:mm:ss");

            response.data.results.map(e => {
              let delayinminutes = moment.duration(
                moment().diff(moment(e.date_created))
              );

              datanya.push({
                call_sign: e.call_sign,
                category: "actual",
                category_id: "0",
                checkedDate: datenow,
                dateCreated: moment(
                  e.date_created,
                  "YYYY-MM-DD HH:mm:ss"
                ).format("DD-MM-YYYY HH:mm:ss"),
                delayinminutes: delayinminutes.asMinutes(),
                inactivetime: "-",
                latitude: e.lat,
                longitude: e.lon,
                name: e.shipname,
                shipid: e.shipid,
                shiptype: e.shiptype,
                status_name: e.status_name
              });
            });

            await this.setState({ datatable: datanya, loader2: false });
            this.setState({ serverSideStatus: false });
          }
        })
        .catch(error => {
          console.log(error);
          this.props.history.push("/pages/login#logout");
        });
    } else {
      fetchInactiveCategory(
        e.target.value,
        this.state.selectedCategoryPeriode,
        this.state.sourceAis
      )
        .then(response => {
          if (response != null) {
            let cat = [];
            let val = [];
            response.data.map(e => {
              if (e[0] !== "-" && e[0] !== null) {
                cat.push(e[0]);
                val.push(e[1]);
              }
            });

            this.setState({
              inactivechartcat: cat,
              inactivechartdata: val
            });
          }
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
      this.handleSearchClick("cat", e.target.value);
      // fetchInactive(
      //   e.target.value,
      //   this.state.selectedCategoryPeriode,
      //   this.state.sourceAis
      // )
      //   .then((response) => {
      //     if (response != null) {
      //       let datanya = [];
      //       for (var key in response.data.results) {
      //         var aa = _.values(response.data.results[key]);
      //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
      //         datanya.push({
      //           name: aa[2],
      //           shiptype: this.getNameshiptype(aa[3]),
      //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
      //             "DD-MM-YYYY HH:mm:ss"
      //           ),
      //           latitude: aa[5],
      //           longitude: aa[6],
      //           category: aa[7],
      //           delayinminutes: parseFloat(aa[11]).toFixed(2),
      //           call_sign: aa[10],
      //           status_name: aa[12],
      //           checkedDate: moment(aa[13], "YYYY-MM-DD HH:mm:ss").format(
      //             "DD-MM-YYYY HH:mm:ss"
      //           ),
      //           inactivetime: ">" + aa[9] + " Hours",
      //         });
      //       }
      //       this.setState({ datatable: datanya });
      //     }
      //   })
      //   .catch((error) => {
      //     //this.props.pushToken(error);
      //   });
    }
  };

  render() {
    const columns = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: this.state.displayStatus[0],
          sortDirection: this.state.sort[0]
        }
      },
      {
        name: "call_sign",
        label: "Call Sign",
        options: {
          filter: false,
          display: this.state.displayStatus[1],
          sortDirection: this.state.sort[1]
        }
      },
      {
        name: "dateCreated",
        label: "Last Update",
        options: {
          filter: false,
          display: this.state.displayStatus[2],
          sortDirection: this.state.sort[2]
        }
      },
      {
        name: "delayinminutes",
        label: "Delay in Minutes",
        options: {
          filter: false,
          display: this.state.displayStatus[3],
          sortDirection: this.state.sort[3]
        }
      },
      {
        name: "checkedDate",
        label: "Checked Time",
        options: {
          filter: false,
          display: this.state.displayStatus[4],
          sortDirection: this.state.sort[4]
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: this.state.displayStatus[5],
          sortDirection: this.state.sort[5]
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: this.state.displayStatus[6],
          sortDirection: this.state.sort[6]
        }
      },
      {
        name: "category",
        label: "Category",
        options: {
          filter: false,
          display: this.state.displayStatus[7],
          sortDirection: this.state.sort[7]
        }
      },
      {
        name: "inactivetime",
        label: "Inactive Time",
        options: {
          filter: false,
          display: this.state.displayStatus[8],
          sortDirection: this.state.sort[8]
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <NavLink
                  to={"/portal"}
                  onClick={() =>
                    this.props.pushPoiTarget([
                      tableMeta.rowData[5],
                      tableMeta.rowData[6]
                    ])
                  }
                >
                  <Button size="sm" color="behance" round>
                    View on Map
                  </Button>
                </NavLink>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: true,
      search: true,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader2
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      },
      onTableChange: async (action, tableState) => {
        if (this.state.serverSideStatus) {
          switch (action) {
            case "changePage":
              this.handleSearch(
                null,
                null,
                tableState.rowsPerPage,
                tableState.page
              );
              break;
            case "changeRowsPerPage":
              this.handleSearch(
                null,
                null,
                tableState.rowsPerPage,
                tableState.page
              );
              break;
            case "propsUpdate":
              if (this.state.searchCheck) {
                this.setState({ searchCheck: false });
                tableState.page = 0;
                tableState.rowsPerPage = 10;
              }
              break;
            case "sort":
              tableState.page = 0;
              const condition = tableState.announceText.split(" ");
              const listColumn = this.state.sort;
              listColumn.forEach((value, index) => {
                let ascdesc;
                if (index === tableState.activeColumn) {
                  if (condition[6] === "ascending") {
                    ascdesc = "asc";
                  } else {
                    ascdesc = "desc";
                  }
                  this.state.sort[tableState.activeColumn] = ascdesc;
                } else {
                  this.state.sort[index] = "none";
                }
              });
              await this.setState({
                orderby:
                  tableState.columns[tableState.activeColumn].name ===
                  "dateCreated"
                    ? `"dateCreated"`
                    : tableState.columns[tableState.activeColumn].name ===
                      "checkedDate"
                      ? `"checkedDate"`
                      : tableState.columns[tableState.activeColumn].name,
                activeColumn: tableState.activeColumn
              });
              this.handleSearch(
                null,
                null,
                tableState.rowsPerPage,
                tableState.page,
                this.state.activeColumn,
                this.state.orderby
              );
              break;
            case "search":
              if (delay !== null) {
                clearTimeout(delay);
              }
              delay = setTimeout(async () => {
                let searchKeyword = tableState.searchText
                  ? tableState.searchText
                  : "";
                await this.handleKeyword(searchKeyword);
                tableState.searchText = this.state.keyword;
              }, 3000);
            case "columnViewChange":
              tableState.columns.forEach((column, index) => {
                if (column.display !== this.state.displayStatus[index]) {
                  this.state.displayStatus[index] = column.display;
                }
              });
            default:
              break;
          }
        }
      },
      serverSide: this.state.serverSideStatus,
      count: this.state.totalData,
      searchText: this.state.keyword
    };

    const optionsChart3 = {
      chart: {
        type: "column"
      },
      title: {
        text: "Vessel Type"
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: this.state.inactivechartcat
      },
      yAxis: {
        title: {
          text: "Volume Vessel"
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        }
      },
      series: [
        {
          name: "Category",
          data: this.state.inactivechartdata
        }
      ]
    };

    return (
      <div>
        <Grid item xs={12}>
          <Button
            color="success"
            round
            onClick={() => this.handleClose("openAdd", true)}
          >
            <IconSettings /> manage category
          </Button>
        </Grid>
        <BlockUi tag="div" blocking={this.state.loader} message="Loading">
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <FormControl variant="outlined">
                  <Select
                    value={this.state.selectedCategory}
                    onChange={this.handlecat}
                  >
                    {this.state.catinactive.map(this.renderOptcat)}
                  </Select>
                </FormControl>{" "}
                <FormControl variant="outlined">
                  <Select
                    value={this.state.selectedCategoryPeriode}
                    onChange={this.handlecatperiode}
                  >
                    <MenuItem value="1"> Daily </MenuItem>
                    <MenuItem value="7"> Weekly </MenuItem>
                    <MenuItem value="30"> Monthly </MenuItem>
                  </Select>
                </FormControl>
                <FormControl variant="outlined">
                  <Select
                    value={this.state.sourceAis}
                    onChange={this.handlecatSource}
                  >
                    <MenuItem value="AIS_MT"> AIS </MenuItem>
                    <MenuItem value="GPS"> GPS </MenuItem>
                  </Select>
                </FormControl>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <b>description: </b>
                {this.state.description}
              </CardContent>
            </Card>
          </Grid>
          <HighchartsReact highcharts={Highcharts} options={optionsChart3} />
        </BlockUi>
        <TextField
          size="small"
          id="datetime-local"
          label="Start Date"
          type="datetime-local"
          className={styles.textField}
          defaultValue={this.state.startDate}
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{
            value: this.state.startDate,
            onChange: this.handleStartDate
          }}
        />
        <TextField
          size="small"
          id="datetime-local"
          label="End Date"
          type="datetime-local"
          className={styles.textField}
          defaultValue={this.state.endDate}
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{
            value: this.state.endDate,
            onChange: this.handleEndDate
          }}
        />
        <Button
          color="primary"
          variant="contained"
          disabled={this.state.loader}
          style={{ marginRight: 20 }}
          onClick={() => this.handleSearchClick()}
        >
          Search
        </Button>
        <ExcelFile
          element={
            <Button
              color="primary"
              variant="contained"
              disabled={this.state.loader}
            >
              Download as .xslx
            </Button>
          }
          filename={`${fileName}`}
          fileExtension="xslx"
        >
          <ExcelSheet data={this.state.dataExcel} name="Sheet 1">
            <ExcelColumn label="Name" value="name" />
            <ExcelColumn label="Call Sign" value="call_sign" />
            <ExcelColumn label="Last update" value="dateCreated" />
            <ExcelColumn label="Delay in Minutes" value="delayinminutes" />
            <ExcelColumn label="Checked Time" value="checkedDate" />
            <ExcelColumn label="Latitude" value="latitude" />
            <ExcelColumn label="Longitude" value="longitude" />
            <ExcelColumn label="Category" value="category" />
            <ExcelColumn label="Inactivetime" value="inactivetime" />
          </ExcelSheet>
        </ExcelFile>
        <MUIDataTable
          data={this.state.datatable}
          columns={columns}
          options={options}
        />
        <Dialog
          maxWidth={"md"}
          open={this.state.openAdd}
          onClose={() => this.handleClose("openAdd", false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Manage Category</DialogTitle>
          <DialogContent>
            <InactiveCat />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleClose("openAdd", false)}
              color="danger"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Inactive.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  pushPoiTarget: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel,
    sourceAis: state.sourceAis
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLeftPanel, pushZonaTarget, pushPoiTarget, pushLoader }
  )(Inactive)
);
